import { handleMessageChange } from "./handleMessageChange";

export function handleUpdateAllCardsButton(
  selectedNode,
  componentType,
  newData,
  buttonIndex, 
  nodes,
  setNodes,
  setCards
) {
  const updatedCards = selectedNode.data.cards.map((card) => {
    // Vérifie que la card possède bien des composants
    if (!card.components || !Array.isArray(card.components)) return card;
    console.log("newData buttons", newData)

    const updatedComponents = card.components.map((component) => {
      if (component.type === componentType) {
        // Pour le composant BUTTONS, on met à jour le bouton dont l'index correspond à buttonIndex
        if (componentType === "BUTTONS" && Array.isArray(component.buttons)) {

          const updatedButtons = component.buttons.map((button, index) => {
            if (index === buttonIndex) {
              let updatedButton = { ...button, ...newData };
              // Si le type dans newData est "QUICK_REPLY", on supprime la clé 'url' de l'objet bouton
              if (newData.type === "QUICK_REPLY") {
                delete updatedButton.url;
              }
              return updatedButton;
            }
            return button;
          });
          return { ...component, buttons: updatedButtons };
        }
        // Pour les autres composants, on fusionne directement newData
        return { ...component, ...updatedData };
      }
      return component;
    });

    return { ...card, components: updatedComponents };
  });

  handleMessageChange("cards", updatedCards, nodes, setNodes);
  setCards(updatedCards)
}